module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "22",
      "height": "16",
      "viewBox": "0 0 22 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.6633 10.1213C13.2259 9.55871 13.542 8.79565 13.542 8C13.542 7.20435 13.2259 6.44129 12.6633 5.87868C12.1007 5.31607 11.3376 5 10.542 5C9.74634 5 8.98328 5.31607 8.42067 5.87868C7.85806 6.44129 7.54199 7.20435 7.54199 8C7.54199 8.79565 7.85806 9.55871 8.42067 10.1213C8.98328 10.6839 9.74634 11 10.542 11C11.3376 11 12.1007 10.6839 12.6633 10.1213Z",
      "stroke": "#3F3F46",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M1 8C2.274 3.943 6.065 1 10.542 1C15.02 1 18.81 3.943 20.084 8C18.81 12.057 15.02 15 10.542 15C6.065 15 2.274 12.057 1 8Z",
      "stroke": "#3F3F46",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a652b64","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/images/svg/Eye.vue
// module id = e047e310cee4eacea490
// module chunks = 89